import logo100Thieves from "@/assets/client-logos/100t.svg";
import logoAbbott from "@/assets/client-logos/abbott.svg";
import logoBi from "@/assets/client-logos/bi.svg";
import logoCloud9 from "@/assets/client-logos/cloud9.svg";
import logoDsm from "@/assets/client-logos/dsm.svg";
import logoEsl from "@/assets/client-logos/esl.svg";
import logoGoons from "@/assets/client-logos/goons.svg";
import logoJnj from "@/assets/client-logos/j-n-j.svg";
import logoMmeets from "@/assets/client-logos/mmeets.svg";
import logoMode from "@/assets/client-logos/mode.svg";
import logoRoche from "@/assets/client-logos/roche.svg";
import logoSkGaming from "@/assets/client-logos/sk-gaming.svg";
import logoSmii7y from "@/assets/client-logos/smii7y.svg";
import logoTMobile from "@/assets/client-logos/t-mobile.svg";
import logoTsm from "@/assets/client-logos/tsm.svg";

const CLIENTS = [
  { name: "100 Thieves", logo: logo100Thieves },
  { name: "Abbott", logo: logoAbbott },
  { name: "Boehringer Ingelheim", logo: logoBi },
  { name: "Cloud9", logo: logoCloud9 },
  { name: "DSM", logo: logoDsm },
  { name: "ESL", logo: logoEsl },
  { name: "Goons", logo: logoGoons },
  { name: "Johnson & Johnson", logo: logoJnj },
  { name: "Mode", logo: logoMode },
  { name: "Munich Meets", logo: logoMmeets },
  { name: "Roche", logo: logoRoche },
  { name: "SK Gaming", logo: logoSkGaming },
  { name: "SMii7Y", logo: logoSmii7y },
  { name: "T-Mobile", logo: logoTMobile },
  { name: "TSM", logo: logoTsm },
] as const;

function LogoSet({ duplicate = false }: { duplicate?: boolean }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={duplicate || undefined}>
      {CLIENTS.map((client) => (
        <div
          key={client.name}
          className="flex h-20 w-36 shrink-0 items-center justify-center px-5 sm:w-44 sm:px-7 md:h-24 md:w-48"
        >
          <img
            src={client.logo}
            alt={duplicate ? "" : client.name}
            width={160}
            height={64}
            loading="lazy"
            decoding="async"
            draggable={false}
            className="max-h-9 w-auto max-w-full rounded-none object-contain brightness-0 opacity-45 md:max-h-10"
          />
        </div>
      ))}
    </div>
  );
}

export function ClientLogos() {
  return (
    <section aria-labelledby="client-logos-heading" className="border-y border-border/70 py-7 md:py-9">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-6 md:px-10">
        <p
          id="client-logos-heading"
          className="text-center text-xs font-medium uppercase text-muted-foreground"
        >
          Previously trusted by
        </p>
      </div>
      <div className="client-logo-viewport mt-3 overflow-hidden md:mt-4">
        <div className="client-logo-track flex w-max">
          <LogoSet />
          <LogoSet duplicate />
        </div>
      </div>
    </section>
  );
}